import { FormattedNumber } from 'react-intl';
import { toUnit } from '@99designs/marketing-ui';
import type { CurrencyCode } from '@99designs/i18n';

export interface Money {
    amountInCents: number;
    currency: CurrencyCode;
}

export function Price({ amountInCents, currency }: Money) {
    return (
        <FormattedNumber
            value={Math.round(toUnit(amountInCents, currency as CurrencyCode))}
            // eslint-disable-next-line react/style-prop-object
            style="currency"
            currency={currency}
            minimumFractionDigits={0}
        />
    );
}
